<template>
    <div class="container-login">
        <div class="body-login">
            <div class="border-login"
                 v-if="!loginPhoneState"
                 >
                <div class="text-name">番茄计划</div>
                <div class="login-weChat my-cursor" @click.stop="weChatLogin">
                    <img class="icon-weChat" src="../../assets/images/Login/icon-weChat.png" alt="">
                    <div class="text-weChat">微信一键登录</div>
                </div>
                <div class="login-items">
<!--                    <div class="login-item my-cursor" @click.stop="appleLogin">-->
<!--                        <img class="icon-login my-cursor" src="../../assets/images/Login/icon-apple.png" alt="">-->
<!--                        <div class="text-login">Apple ID</div>-->
<!--                    </div>-->
                    <div class="login-item my-cursor" @click.stop="switchLoginPhone">
                        <img class="icon-login" src="../../assets/images/Login/icon-phone.png" alt="">
                        <div class="text-login">手机号登录</div>
                    </div>
                    <div class="login-item my-cursor" @click.stop="tencentLogin">
                        <img class="icon-login" src="../../assets/images/Login/icon-qq.png" alt="">
                        <div class="text-login">QQ登录</div>
                    </div>
                </div>
            </div>

            <div class="border-login fade-in"

                 v-if="loginPhoneState">
                <div class="text-title">手机号登录</div>
                <img class="icon-back my-cursor"
                     @click.stop="switchLoginPhone"
                     src="../../assets/images/Login/icon-back.png" alt="">
                <div class="input-border">
                    <img class="icon-input" src="../../assets/images/Login/icon-input-phone.png" alt="">
                    <label>
                        <input class="input-phone" v-model="phone"
                               @keyup.stop="setLoginKeyUp(0,$event)"
                               maxlength="11" placeholder="请输入手机号"
                               type="text">
                    </label>
                </div>
                <div class="input-border">
                    <img class="icon-input" src="../../assets/images/Login/icon-input-code.png" alt="">
                    <div class="get-code my-cursor" v-show="!timer.state" @click.stop="getMobileCode()">获取验证码</div>
                    <div class="loading-code" v-show="timer.state">重新获取({{ timer.second }}s)</div>

                    <label>
                        <input ref="input-code" class="input-code" v-model="code"
                               @keyup.stop="setLoginKeyUp(1,$event)"
                               maxlength="6" placeholder="请输入验证码"
                               type="text">
                    </label>
                </div>
                <div class="login-in my-cursor" @click.stop="loginByPhone">
                    登录
                    <i class="el-icon-loading" v-show="logging"></i>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return {
            loginPhoneState: false,
            phone: "",
            code: "",
            logging: false,
            redirectURL: "",

            timer: {
                second: 60,
                state: false,
            },
        }
    },
    watch: {
        phone: function(){
            this.phone = this.phone.replace(/[\D]/g,'');
        },
        code: function(){
            this.code = this.code.replace(/[\D]/g, '');
        }
    },
    methods: {
        switchLoginPhone: function(){
            this.loginPhoneState = !this.loginPhoneState;
        },
        setLoginKeyUp: function(inputType, e){
            if(inputType === 0){
                if(e.keyCode === 13){
                    // 聚焦验证码
                    this.$refs["input-code"].focus();
                }
            }else{
                if(e.keyCode === 13){
                    // 登录
                    this.loginByPhone();
                }
            }
        },

        getMobileCode: function(){
            if(this.phone.length < 11 || !/^1([3456789])\d{9}$/.test(this.phone)){
                this.$PopupToast("请输入正确格式或有效的手机号");
                return
            }
            this.timer.state = true;
            this.$api.getMobileCaptcha({
                mobile: this.phone
            }).then((res)=>{
                if(res.data.code === 200){
                    console.log("获取验证码成功！")
                }else{
                    this.$PopupToast('获取验证码失败');
                }
            });
            let e = setInterval(()=>{
                this.timer.second--;
                if(this.timer.second <= 0){
                    this.timer.state = false;
                    this.timer.second = 60;
                    clearInterval(e);
                }
            }, 1000)
        },
        /**
         * 2.手机号登录：获取jwt
         */
        loginByPhone: function(){

            if(this.phone.length < 11 || !/^1([3456789])\d{9}$/.test(this.phone)){
                // 校验手机号
                this.$PopupToast("请输入正确格式或有效的手机号");
                return
            }
            if(this.code.length < 6){
                this.$PopupToast("验证码不正确或超时");
                return
            }

            this.logging = true;
            this.$api.getLoginByMobile({
                mobile: this.phone,
                captcha: this.code
            }).then((res)=>{
                if(res.data.code === 200){
                    this.saveLoginInfo(res.data.data);
                    this.$PopupToast('登陆成功');
                }else{
                    this.$PopupToast('登陆失败');
                }
                this.logging = false;
            })
        },
        /**
         * 1. QQ登陆，获取Code&state
         */
        tencentLogin:function(){
            window.location.href = `https://graph.qq.com/oauth2.0/authorize?client_id=102107814&redirect_uri=${this.redirectURL}&response_type=code&scope=get_user_info&state=qq_login`;
        },
        /**
         * 1.微信登录：获取code
         */
        weChatLogin: function() {
            window.location.href = "https://open.weixin.qq.com/connect/qrconnect?appid=wx2b4a52d0a7ab8546&redirect_uri=" + this.redirectURL + "&response_type=code&scope=snsapi_login&state=wechat_login#wechat_redirect";
        },
        /**
         * 1.apple登录：获取code
         */
        appleLogin: function(){
            window.location.href = `https://appleid.apple.com/auth/authorize?client_id=jihua.cn.fanqie.applelogin.web&redirect_uri=${this.redirectURL}&response_type=code&scope=&state=apple_login`;
        },
        /**
         * 使用正则提取code值
         */
        getWeChatParam: function(url, code) {
            url += "";

            var regStr = "/(\\?|\\&)" + code + "=([^\\&]+)/",
                reg = eval(regStr),
                result = url.match(reg);
            if (result && result[2]){
                if(url.search("state=wechat_login") !== -1){
                    // 微信的Code
                    this.weChatInfo(result[2]);
                }else if(url.search("state=qq_login") !== -1){
                    // QQ的Code
                    this.tencentInfo(result[2])
                }else{
                    // 苹果的Code
                    this.appleInfo(result[2])
                }
            }
        },
        /**
         * 微信 获取用户信息
         * @param weChatLoginCode
         */
        weChatInfo: function(weChatLoginCode){
            const that = this;
            this.logging = true;
            this.$api.getWeChatInfo({
                code: weChatLoginCode
            }).then((res)=>{
                if(res.data.code===200){
                    that.loginByWechat({
                        unionId: res.data.data.unionid,
                        nickName: res.data.data.nickname,
                        picture: res.data.data.headimgurl
                    });
                }else{
                    that.$PopupToast('授权失败');
                    that.logging = false;
                }
            })
        },
        /**
         * 微信登录朝暮计划
         */
        loginByWechat: function(params){
            const that = this;
            this.$api.getLoginByWeChat(params).then((res)=>{
                if(res.data.code === 200){
                    that.saveLoginInfo(res.data.data);
                    that.$PopupToast('微信登录成功');
                }else{
                    that.$PopupToast('微信登录失败');
                }
                that.logging = false;
            })
        },
        /**
         * QQ 登录并获取用户信息
         */
        tencentInfo: function(tencentLoginCode){
            const that = this;
            this.logging = true;
            this.$api.getTencentInfo({
                code: tencentLoginCode,
                redirect_uri: this.redirectURL,
            }).then((res)=>{
                if(res.data.code===200){
                    that.loginByTencent({
                        openId: res.data.data.qqId,
                        unionId: res.data.data.unionId,
                        nickName: res.data.data.nickname,
                        picture: res.data.data.qqPhoto
                    });
                }else{
                    that.$PopupToast("授权失败");
                    that.logging = true;
                }
            })
        },
        /**
         * QQ登录朝暮计划
         * @param params
         */
        loginByTencent: function(params){
            const that = this;
            this.$api.getLoginByTencent(params).then((res)=>{
                if(res.data.code === 200){
                    that.saveLoginInfo(res.data.data);
                    that.$PopupToast("QQ登陆成功");
                }else{
                    that.$PopupToast("QQ登录失败");
                }
                that.logging = false;
            })
        },
        /**
         * Apple 获取用户信息
         * @param appleLoginCode
         */
        appleInfo: function(appleLoginCode){
            const that = this;
            this.logging = true;
            this.$api.getAppleInfo({
                code: appleLoginCode
            }).then((res)=>{
                if(res.data.code===200){
                    that.loginByApple({
                        identityToken: res.data.data.idToken
                    });
                }else{
                    that.$PopupToast('授权失败');
                    that.logging = false;
                }
            })
        },
        /**
         * Apple登录朝暮计划
         * @param params
         */
        loginByApple: function(params){
            const that = this;
            this.$api.getLoginByApple(params).then((res)=>{
                if(res.data.code === 200){
                    that.saveLoginInfo(res.data.data);
                    that.$PopupToast("Apple登陆成功");
                }else{
                    that.$PopupToast("Apple登录失败");
                }
                that.logging = false;
            })
        },
        /**
         * 登录成功，保存登录信息
         * @param data
         */
        saveLoginInfo: function(data){
            // 存入Token
            window.localStorage.setItem("jwt", data.jwt);
            window.localStorage.setItem("userId", data.userId);
            this.$router.push('/');
        },
    },
    created: function() {

        const sourceUrl = window.location.href;
        this.redirectURL = encodeURIComponent(sourceUrl);
        this.getWeChatParam(sourceUrl, "code");
    },
}
</script>

<style scoped>
div.container-login{
    width: 100%;
    height: 100%;
    background: #FFFEF2;
    display: inline-block;
    padding-top: 20vh;
    box-sizing: border-box;
}

div.body-login{
    width: 5.86rem;
    height: auto;
    margin: auto;
    background: #FFFFFF;
    border-radius: 0.3rem;
    padding: 0.1rem;
    box-sizing: border-box;
}
div.border-login{
    width: 100%;
    height: auto;
    padding: 0.5rem 0;
    box-sizing: border-box;
    border: 0.02rem solid #000000;
    border-radius: 0.3rem;
}
div.text-name{
    font-weight: bold;
    font-size: 0.5rem;
    color: #000000;
    line-height: 0.6rem;
    text-align: center;
}
div.login-weChat{
    width: 4.27rem;
    height: 0.62rem;
    box-sizing: border-box;
    background: #FEE494;
    border-radius: 0.1rem;
    border: 0.03rem solid #000000;
    margin: 0.9rem auto auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.08rem;
}
img.icon-weChat{
    width: 0.32rem;
    height: 0.27rem;
}
div.text-weChat{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
}
div.login-items{
    width: 100%;
    margin-top: 1rem;
    box-sizing: border-box;
    padding: 0 1.28rem;
    display: flex;
    justify-content: space-between;
}
div.login-item{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 0.04rem;
}
img.icon-login{
    width: 0.5rem;
    height: 0.5rem;

}
div.text-login{
    font-size: 0.14rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: center;
}

div.text-title{
    font-weight: bold;
    font-size: 0.5rem;
    color: #000000;
    line-height: 0.6rem;
    text-align: center;
}
img.icon-back{
    width: 0.26rem;
    height: 0.26rem;
    float: left;
    margin-top: -0.34rem;
    margin-left: 0.24rem;
}
div.input-border{
    width: 4.27rem;
    height: 0.62rem;
    position: relative;
    margin: 0.5rem auto auto;
}
div.input-border:nth-of-type(3){
    margin: 0.24rem auto auto;
}
img.icon-input{
    width: 0.22rem;
    height: 0.28rem;
    position: absolute;
    margin-top: 0.17rem;
    margin-left: 0.24rem;
}
input.input-phone, input.input-code{
    width: 100%;
    height: 100%;

    font-weight: 500;
    font-size: 0.18rem;
    color: #000000;
    text-align: left;
    text-indent: 0.6rem;

    display: block;
    border-radius: 0.1rem;
    border: 0.03rem solid #000000;
    box-sizing: border-box;
}

input.input-phone::placeholder, input.input-code::placeholder{
    font-weight: 400;
}

div.get-code, div.loading-code{
    height: 100%;
    position: absolute;
    right: 0;

    font-weight: bold;
    font-size: 0.18rem;
    color: #FC8470;
    text-align: right;
    line-height: 0.62rem;
    padding-right: 0.24rem;

}
div.loading-code{
    color: rgba(0, 0, 0, 0.5);
}
div.login-in{
    width: 4.27rem;
    height: 0.62rem;
    background: #FEE494;
    border-radius: 0.1rem;
    border: 0.03rem solid #000000;

    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    text-align: center;
    line-height: 0.56rem;
    box-sizing: border-box;
    margin: 0.5rem auto auto;
}

div.fade-in{
    transition: fadeIn 0.5s linear;
}
div.fade-out{
    transition: fadeOut 0.5s linear;
}

@keyframes fadeIn {
    from {opacity: 0}
    to {opacity: 1}
}
@keyframes fadeOut {
    from {opacity: 1}
    to {opacity: 0}
}
</style>